import { render } from "./GameAlUsage.vue?vue&type=template&id=c4ea5308&ts=true"
import script from "./GameAlUsage.vue?vue&type=script&lang=ts"
export * from "./GameAlUsage.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__